module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "part-1"
  }, [_c('div', {
    staticClass: "nav"
  }, _vm._l((_vm.navItem), function(item, index) {
    var _obj;

    return _c('div', {
      key: index,
      class: [( _obj = {}, _obj['active'] = _vm.activeIndex == index, _obj )],
      on: {
        "click": function($event) {
          return _vm.switchNav(index)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), (_vm.activeIndex === 0) ? _c('div', {
    staticClass: "content content1"
  }, [_vm._v("广西百色翠丰特色农产品有限责任公司主要经营：水果、食用菌、田七、农副土特产品、家禽、水产品、茶叶、预包装食品贸易等产品。\n")]) : _vm._e(), _vm._v(" "), (_vm.activeIndex === 1) ? _c('div', {
    staticClass: "content content2"
  }, [(_vm.banner.length != 0) ? _c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper-wrap",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.banner), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('img', {
      attrs: {
        "src": item,
        "alt": "",
        "width": "152px"
      }
    })])
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next"
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-379957ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/leftDetails/index.vue
// module id = 1977
// module chunks = 2